import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { useTopic } from 'hooks/useTopic';
import { Inroduction } from '../hand-hygiene/inroduction';
import { PreparingYourHandsToWork } from '../hand-hygiene/preparing-your-hands-to-work';
import { ProperHandWashing } from '../hand-hygiene/proper-hand-washing';
import { ProperHandDisinfection } from '../hand-hygiene/proper-hand-disinfection';
import { HandHygieneAndMedicalGloves } from '../hand-hygiene/hand-hygiene-and-medical-gloves';
import { FiveMomentsHandHygiene } from '../hand-hygiene/five-moments-hand-hygiene';
import { HandHygieneQuiz } from '../hand-hygiene/quiz';

export const GenericTopicPage = () => {
    const { currentIssue, tasks, correctAnswer, isAnswerChecked } = useTopic();

    const issueComponentMap: Record<string, JSX.Element> = {
        'WPROWADZENIE': <Inroduction />,
        'PRZYGOTOWANIE RĄK DO PRACY A DEZYNFEKCJA': <PreparingYourHandsToWork />,
        'TECHNIKA DEZYNFEKCJI RĄK': <ProperHandDisinfection />,
        'TECHNIKA MYCIA RĄK': <ProperHandWashing />,
        'PRZYGOTOWANIE RĄK DO PRACY A UŻYCIE RĘKAWICZEK': <HandHygieneAndMedicalGloves />,
        '5 MOMENTÓW HIGIENY RĄK WG WHO': <FiveMomentsHandHygiene />,
        'q': <HandHygieneQuiz />,
    };

    const legacyComponent = currentIssue
        ? issueComponentMap[currentIssue.name ?? currentIssue.path] ?? null
        : null;
    
    return (
        <div className="container">
            {legacyComponent ?? (
                <TasksGenerator
                    tasks={tasks}
                    isChecked={isAnswerChecked}
                    correctAnswer={correctAnswer}
                    isQuiz={false}
                />
            )}
        </div>
    );
};